import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class BasicSearchService {
  private baseUrl = environment.baseUrl;

  constructor(private http: HttpClient) {}

  startSearch(
    phones: string[],
    ipAddress?: string,
    location?: string,
  ): Observable<any> {
    const payload: any = { phones };
    if (ipAddress) payload.ip_address = ipAddress;
    if (location) payload.location = location;
    return this.http.post(`${this.baseUrl}/basic/search`, payload);
  }

  getHistory(params: Record<string, any> = {}): Observable<any> {
    let httpParams = new HttpParams();
    Object.entries(params).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        httpParams = httpParams.set(key, String(value));
      }
    });
    return this.http.get(`${this.baseUrl}/basic/history`, { params: httpParams });
  }

  getStatus(basicSearchId: string): Observable<any> {
    return this.http.get(`${this.baseUrl}/basic/status/${basicSearchId}`);
  }

  getResult(basicSearchId: string): Observable<any> {
    return this.http.get(`${this.baseUrl}/basic/results/${basicSearchId}`);
  }

  deleteHistory(basicSearchIds: string[]): Observable<any> {
    return this.http.delete(`${this.baseUrl}/basic/history`, {
      body: { basic_search_ids: basicSearchIds },
    });
  }

  updateNotes(basicSearchId: string, notes: string): Observable<any> {
    return this.http.put(`${this.baseUrl}/basic/notes/${basicSearchId}`, {
      notes,
    });
  }
}
